import React from "react";
import {
  FaInstagram,
  FaFacebookF,
  FaLinkedinIn,
  FaTwitter,
} from "react-icons/fa";
import "./FollowConnect.css";

export default function FollowConnect() {
  return (
    <section className="container follwconnect-wrapper">
      <div className="row follow-connect d-flex justify-content-center align-content-center align-items-center">
        <div className="overlay">
          <h2>Follow & Connect</h2>
          <p className="text-center mx-auto">
            Stay connected with us for the latest updates on AMPP
            certifications, course schedules, and industry insights.
          </p>
          <div className="social-icons">
            <a
              href="https://www.instagram.com/agep_india"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.facebook.com/agepinternational"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://www.linkedin.com/company/agepindia"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedinIn />
            </a>
            <a
              href="https://twitter.com/AGEPIndia?t=v2tFDaWa-j99yqz-kNW7rA&s=08"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaTwitter />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
